import Vue from 'vue';
import injector from 'vue-inject';
import store from '../store';

require('./popup');

const api   = injector.get('api');
const popup = injector.get('popup');

class Code {
    fetchList(params) {
        let url = params ? api.codes.list(params) : api.codes.list(store.getters.listSettings);
        store.commit('startListLoading');
        Vue.http.get(url).then(response => {
            store.commit('setList', response.body);
        });
    }
    confirmCode(hash) {
        store.commit('startListLoading');
        Vue.http.post(api.codes.confirm, { hash }).then(() => {
            store.dispatch('listSetPage', 1).then(() => {
                this.fetchList();
                popup.show('Congratulations! You have confirmed your voucher.');
            });
        }).catch(error => {
            popup.show(error.body.errors[0].message);
        });
    }
    cancelCode(code) {
        store.commit('startListLoading');
        Vue.http.post(api.codes.cancel, {codeId: code.codeId}).then(() => {
            store.dispatch('listSetPage', 1).then(() => {
                store.commit('cancelCode', code);
                this.fetchList();
            });
        }).catch(error => {
            popup.show(error.body.message);
        });
    }
    createCode(amount) {
        store.commit('startCreateLoading');
        Vue.http.post(api.codes.create, {amount: amount}).then(() => {
            store.dispatch('listSetPage', 1).then(() => {
                store.commit('stopCreateLoading');
                this.fetchList();
            });
        }).catch(error => {
            popup.show(error.body.errors[0].message);
            store.commit('stopCreateLoading');
        });
    }
}

injector.service('code', Code);



// WEBPACK FOOTER //
// ./src/services/code.js